import React, { createContext, useContext, useState } from "react";
import { getUserData } from "../../Actions/common";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
    const [userDetails, setUserDetails] = useState(() => {
        const storedUserData = localStorage.getItem("userData")
            ? getUserData()
            : null;
        return storedUserData ? storedUserData : null;
    });

    const updateUserData = (newUserData) => {
        setUserDetails(newUserData);
    };

    return (
        <ProfileContext.Provider value={{ userDetails, updateUserData }}>
            {children}
        </ProfileContext.Provider>
    );
};

export const useUser = () => useContext(ProfileContext);
